import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import { useTranslation } from 'react-i18next';

export default function BasicPie({
  data,
}: {
  data: any;
}) 

{
const {t} = useTranslation() as { t: (key: string) => string};
 const { i18n } = useTranslation() as { i18n: any };
const lange = i18n.language;

  return (
    <div className='bg-white  shadow-md xs:w-[400px] s:w-[340px] rounded-lg'>

      <div  className=" text-[#233D4D] text-xl p-4 font-semibold mb-4">
        {t("Statistiques de réservation du mois de")} {new Date().toLocaleString(lange === 'fr' ? "fr-FR" : "en-EN", { month: "long" })}
      </div>

      <PieChart className='mt-20  s:w-[300px] xs:w-[400px]'
        series={[
          {
            data: [
              { id: 0, value: data[0], label: t('Residence') },
              { id: 1, value: data[1], label: t('Restaurant') },
              { id: 2, value: data[2], label: t('Véhicule') },
              { id: 3, value: data[3], label: t('Loisir') },
              { id: 4, value: data[4], label: t('Tourisme') },
            ],
          },
        ]}
        
        height={200}
      />
    </div>
  );
}